import React, { useEffect, useRef, useState } from "react";
import '../AddZones/AddZones.scss';
import DeviceActionIcon from "../../assets/images/icCar-action.png";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import MultiSelectCheckbox from "./MultiSelectCheckbox ";
import DeleteModal from "../Deletemodal/DeleteModal";
import {
  APIProvider,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import useApi from "../../hook/useAPI";
import { DEVICE, ZONES, ZONESGroup } from "../../utils/const";
import { toast } from "react-toastify";
import { GOOGLE_KEY } from "../../constants/Constant";

const API_KEY = GOOGLE_KEY;
const ZONE_LIST_LIMIT = 100;

// const zoneGroup = [
//   { id: 1, name: "Zone Group A", address: "City, State, Address" },
//   { id: 2, name: "Zone Group B", address: "City, State, Address" },
//   { id: 3, name: "Zone Group C", address: "City, State, Address" },
//   { id: 4, name: "Zone Group D", address: "City, State, Address" },
//   { id: 5, name: "Zone Group E", address: "City, State, Address" },
//   { id: 6, name: "Zone Group F", address: "City, State, Address" },
//   { id: 7, name: "Zone Group G", address: "City, State, Address" },
//   { id: 8, name: "Zone Group H", address: "City, State, Address" },
//   { id: 9, name: "Zone Group I", address: "City, State, Address" },
//   { id: 10, name: "Zone Group J", address: "City, State, Address" },
//   { id: 11, name: "Zone Group K", address: "City, State, Address" },
//   { id: 12, name: "Zone Group L", address: "City, State, Address" },
//   { id: 13, name: "Zone Group M", address: "City, State, Address" },
//   { id: 14, name: "Zone Group N", address: "City, State, Address" },
//   { id: 15, name: "Zone Group O", address: "City, State, Address" },
//   { id: 16, name: "Zone Group P", address: "City, State, Address" },
//   { id: 17, name: "Zone Group Q", address: "City, State, Address" },
//   { id: 18, name: "Zone Group R", address: "City, State, Address" },
//   { id: 19, name: "Zone Group S", address: "City, State, Address" },
//   { id: 20, name: "Zone Group T", address: "City, State, Address" }
// ];


function AddZones({ handleMenu, handlezone, onSelectZone, newZoneSelection, onCreateZone }) {
  const { getData, postData, putData, deleteData } = useApi();
  const [isCardVisible, setIsCardVisible] = useState(false);
  const [zoneGroupToggle, setZoneGroupToggle] = useState(false);
  const [deviceTouchToggle, setDeviceTouchToggle] = useState(false);
  const [zoneTouchToggle, setZoneTouchToggle] = useState(false);
  // const [zoneLocationToggle, setZoneLocationToggle] = useState(false);
  const [deleteshow, setDeleteShow] = useState(false);
  // const [location, setLocation] = useState({
  //   longitude: "",
  //   latitude: ""
  // })
  const [Id, setId] = useState("");
  const initialState = {
    name: "",
    radius: 5,
    zoneLocation: ""
  };
  const [zoneData, setZoneData] = useState(initialState);
  const [zoneList, setZoneList] = useState();
  const [zoneGroupList, setZoneGroupList] = useState()
  const [deviceList, setDeviceList] = useState();
  const zoneNamePattern = /^[a-zA-Z\s-_]*$/;
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectedZone, setSelectedZone] = useState([]);
  const [zoneGroupValue, setZoneGroupValue] = useState("")
  const transformedZoneGroup = zoneList?.map((zone) => ({
    value: zone?._id,
    label: zone?.name,
  }));
  const fetchSingleZone = async () => {
    if (typeof Id === 'string' && Id) {

      try {
        const response = await getData(`${ZONES?.GET_ALL_ZONES}`, Id);

        if (response?.status === 200 && Array.isArray(response?.data) && response.data.length > 0) {
          setZoneData(response.data[0])
          const devices = deviceList
            ?.filter(item => {
              const isMatch = response.data[0]?.devices?.includes(String(item._id));
              return isMatch;
            })
            ?.map(item => item._id);
          setSelectedDevices(devices);
        } else if (response?.status === 200) {
          setZoneData(initialState);
          setSelectedDevices([]);
        } else {
          console.error('Failed to fetch zone:', {
            status: response?.status,
            message: response?.message,
            zoneId: Id,
          });
        }
      } catch (err) {
        console.error('Error fetching zone:', err);
      }
    }
  };

  const fetchSingleZoneGroup = async () => {
    if (typeof Id === 'string' && Id) {
      try {
        const response = await getData(`${ZONESGroup?.GET_ALL_ZONES}`, Id);
        if (response?.status === 200 && response?.data) {
          // Single zone group payload is an object, not an array.
        } else if (response?.status === 200) {
          console.error('Zone group not found:', { zoneGroupId: Id });
        } else {
          console.error('Failed to fetch zone group:', {
            status: response?.status,
            message: response?.message,
            zoneGroupId: Id,
          });
        }
      } catch (err) {
        console.error('Error fetching zone group:', err);
      }
    }
  }
  const fetchDevice = async () => {
    try {
      const response = await getData(
        `${DEVICE?.GET_CURRENT_DEVICE_STATUS}?page=${1}&limit=${10}`
      );
      if (response?.status === 200) {
        setDeviceList(Array.isArray(response?.data) ? response.data : []);
      } else {
        console.error('Failed to fetch devices:', {
          status: response?.status,
          message: response?.message,
        });
      }
    } catch (err) {
      console.error('Error fetching devices:', err);
    }
  };

  const fetchZone = async () => {
    try {
      const response = await getData(`${ZONES?.GET_ALL_ZONES}/?page=${1}&limit=${ZONE_LIST_LIMIT}`);

      if (response?.status === 200) {
        setZoneList(Array.isArray(response?.data) ? response.data : []);
      } else {
        console.error('Failed to fetch zones:', {
          status: response?.status,
          message: response?.message,
        });
      }
    } catch (err) {
      console.error('Error fetching zones:', err);
    }
  };

  const fetchZoneGroup = async () => {
    try {
      const response = await getData(`${ZONESGroup?.GET_ALL_ZONES}/?page=${1}&limit=${ZONE_LIST_LIMIT}`);

      if (response?.status === 200) {
        setZoneGroupList(Array.isArray(response?.data) ? response.data : []);
      } else {
        console.error('Failed to fetch zone groups:', {
          status: response?.status,
          message: response?.message,
        });
      }
    } catch (err) {
      console.error('Error fetching zone groups:', err);
    }
  };
  useEffect(() => {
    fetchDevice();
    fetchZone();
    fetchSingleZone()
    fetchZoneGroup()
    fetchSingleZoneGroup()
  }, [Id])

  useEffect(() => {
    const selectedZone = zoneGroupList?.filter((data) => data?.zoneGroup?._id === Id);
    if (zoneGroupToggle) {
      setSelectedZone(selectedZone[0]?.zones);
      setZoneGroupValue(selectedZone[0]?.zoneGroup?.name);
    }
    // else{

    //   if(Id){

    //     setZoneData({ name: "test",
    //       zoneLocation: "test zone",
    //       radius: 100,
    //       })
    //       setSelectedDevices(["Device 1" , "Device 2"])
    //   }else{
    //     setZoneData(initialState)
    //   }
    // }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Id])
  const toggleCard = (zone) => {
    setIsCardVisible(true);
    if (zone === "zoneGroupe") {
      setZoneGroupToggle(true);
    }
  };
  const handleClosedelete = () => {
    setDeleteShow(false)
    setId("")
  }
  const handleEdit = (editId, zoneValue) => {
    setIsCardVisible(true);
    if (zoneValue === "zoneGroupe") {
      setZoneGroupToggle(true);
      fetchSingleZoneGroup()
    }
    setId(editId)
  }
  const handleDelete = (deleteId, zoneValue) => {
    setDeleteShow(true)
    setId({ id: deleteId, zone: zoneValue })
  }
  const DeleteData = async () => {
    if (Id.zone === "zoneGroup") {
      //Api Call hear for zoneGroup delete
      try {
        if (Id) {
          const response = await deleteData(`${ZONESGroup?.DELETE_ZONE}/${Id?.id}`);
          if (response?.status == 200) {
            toast.success(response?.message);
            fetchZoneGroup();
            setId("")
          }
        }

      } catch (error) {
        console.error("Error delete device", error);
      }
      setDeleteShow(false)
    } else {
      try {
        if (Id) {
          const response = await deleteData(`${ZONES?.DELETE_ZONE}/${Id?.id}`);
          if (response?.status == 200) {
            toast.error(response?.message);
            fetchZone();
            handlezone();
            setId("")
          }
        }

      } catch (error) {
        console.error("Error delete device", error);
      }
      setDeleteShow(false)
    }
  }
  const closeCard = () => {
    setIsCardVisible(false);
    setZoneGroupToggle(false);
    setSelectedDevices([])
    setDeviceTouchToggle(false)
    setSelectedZone([])
    setZoneTouchToggle(false)
    setId("")
    setZoneData(initialState)
    fetchZone();
    setZoneGroupValue("")
    fetchZoneGroup();
  };

  const clearSelection = () => {
    setSelectedZone([]);
    setZoneGroupValue('')
  };
  const zoneSchema = Yup.object().shape({
    name: Yup.string()
      .required("Please enter zone name")
      .matches(
        zoneNamePattern,
        "Please enter a valid zone name only characters allowed."
      ),
    zoneLocation: Yup.string().required("Zone Location is required"),
    // zoneLocation: Yup.string()
    //   .required("Please enter zone Location"),

  });


  const handlesubmitzonegroup = async () => {
    if (selectedZone?.length > 0 && zoneGroupValue !== "") {
      const payload = {
        "name": zoneGroupValue,
        "zoneIds": selectedZone
      }

      if (Id) {
        const response = await putData(`${ZONESGroup.CREATE_ZONE}/${Id}`, payload);
        if (response?.status === 200) {
          toast.success(response?.message);
          fetchZoneGroup();
          closeCard();
        }
      }
      else {
        const response = await postData(ZONESGroup.CREATE_ZONE, payload)
        if (response?.status === 201) {
          toast.success(response?.message);
          fetchZoneGroup();
          closeCard();
        }
      }
    }
  }

  const handleSubmit = async (formData) => {
    const deviceIds = await deviceList?.filter(item => selectedDevices?.includes(item._id))?.map(item => item._id);
    if (selectedDevices.length > 0) {
      const payload = {
        name: formData?.name,
        latitude: formData?.latitude?.toString(),
        longitude: formData?.longitude?.toString(),
        radius: formData?.radiusInMiles,
        deviceIds: deviceIds
      };
      if (Id) {

        const response = await putData(`${ZONES.CREATE_ZONE}/${Id}`, payload);
        if (response?.status === 200) {
          toast.success(response?.message);
          fetchZone();
          handlezone();
          closeCard();
        }

      } else {

        const response = await postData(ZONES.CREATE_ZONE, payload);
        if (response?.status === 201) {
          toast.success(response?.message);
          fetchZone();
          newZoneSelection(true);
          onCreateZone(response?.zone)
          handlezone();
          closeCard();
        }
      }
    }
  };

  const handleZoneNameChange = (zoneName) => {
    setZoneGroupValue(zoneName);
  }

  return (
    <APIProvider apiKey={API_KEY}>
      <>
        {!isCardVisible ? (
          <div className="card external-share-card ">
            <div className="card-body">
              <div className="home-device-box">
                <div className="top_bar">
                  <div className="card_title">Zones</div>
                  <div className="form_field_wrapper">
                    <button className="url-button" onClick={() => toggleCard('zone')}>
                      Add New Zone
                    </button>
                  </div>
                </div>
                <div className="bottom_bar">
                  <div className="device-list-box">
                    {zoneList?.map((item, index) => (
                      <div key={index} className="device-list" style={{ cursor: "pointer" }}>
                        <>
                          <div className="device-name " onClick={() => { handleMenu(item); }}>
                            <h5 className="ellipsis-text">{item.name}</h5>

                            <p className="ellipsis-text">{item.address || item.zoneLocation || "—"}</p>
                          </div>
                          <div className="device-name" onClick={() => { handleMenu(item); }}>
                            <p>{item.totalDevices} Devices</p>
                          </div>
                          <div className="device-action">
                            <button
                              id="dropdownMoreMenu1"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <img
                                src={DeviceActionIcon}
                                className="img-fluid"
                                alt="three-dot-image"
                              />
                            </button>
                            <ul
                              className="profile dropdown-menu"
                              aria-labelledby="dropdownMoreMenu1"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  cursor: "pointer",
                                }}
                              >
                                <li>
                                  <div
                                    className="dropdown-item"
                                    onClick={() => handleEdit(item._id, "zone")}
                                  >
                                    <span className="item_text">Edit</span>
                                  </div>
                                </li>
                                <li>
                                  <div
                                    className="dropdown-item"
                                    onClick={() =>
                                      handleDelete(item._id, "zone")
                                    }
                                  >
                                    <span className="item_text">Delete</span>
                                  </div>
                                </li>
                              </div>
                            </ul>
                          </div>
                        </>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="home-device-box">
                <div className="top_bar">
                  <div className="card_title">Zone Group</div>
                  <div className="form_field_wrapper">
                    <button className="url-button" onClick={() => toggleCard("zoneGroupe")}>
                      Add New Zone Group
                    </button>
                  </div>
                </div>
                <div className="bottom_bar">
                  <div className="device-list-box">
                    {zoneGroupList?.map((zone, index) => {
                      return (
                        <div key={index} className="device-list">
                          <div className="device-name " >
                            <h5 className="ellipsis-text">{zone?.zoneGroup?.name}</h5>

                            {/* <p className="ellipsis-text">{zone?.address}...</p> */}
                          </div>
                          <div className="device-name">
                            <p>{zone?.totalDevices} Devices</p>
                          </div>

                          <div className="device-action">
                            <button id="dropdownMoreMenu1" data-bs-toggle="dropdown"
                              aria-expanded="false">
                              <img
                                src={DeviceActionIcon}
                                className="img-fluid"
                                alt="three-dot-image"
                              />
                            </button>
                            <ul className="profile dropdown-menu" aria-labelledby="dropdownMoreMenu1">
                              <div style={{ display: "flex", flexDirection: "column", cursor: "pointer" }}>
                                <li>
                                  <div
                                    className="dropdown-item"
                                    onClick={() =>
                                      handleEdit(zone?.zoneGroup?._id, "zoneGroupe")
                                    }
                                  >
                                    <span className="item_text">Edit</span>
                                  </div>
                                </li>
                                <li>
                                  <div
                                    className="dropdown-item"
                                    onClick={() =>
                                      handleDelete(zone?.zoneGroup?._id, "zoneGroup")
                                    }
                                  >
                                    <span className="item_text">Delete</span>
                                  </div>
                                </li>
                              </div>
                            </ul>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          // {/* create new zone card start  */}
          <div className="card external-share-card">
            <div className="card-body">
              {zoneGroupToggle ? (
                <div className="home-device-box">
                  <div className="top_bar">
                    <div className="card_title">{Id?.length > 0 ? "Edit" : "Create New"} Zone Group</div>
                    <div className="form_field_wrapper">
                      <button
                        className="url-button closebutton"
                        onClick={closeCard}
                      >
                        <i class="bi bi-x-circle"></i>
                      </button>
                    </div>
                  </div>
                  <div className="bottom_bar">
                    <div className="form-container addzone-group-block">
                      <div className="zone-filter-group">
                        <div className="form_field_wrapper">
                          <label>Select Zone</label>
                          <MultiSelectCheckbox
                            selectedDevices={selectedZone}
                            setSelectedDevices={setSelectedZone}
                            deviceTouchToggle={zoneTouchToggle}
                            setDeviceTouchToggle={setZoneTouchToggle}
                            optionData={transformedZoneGroup}
                          />
                          {zoneTouchToggle && selectedZone?.length === 0 && (
                            <div className="error-message">
                              Please select zone
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="zone-filter-group">
                        <div className="form_field_wrapper">
                          <label>Enter Zone Group Name</label>
                          <input
                            className="form-control"
                            placeholder="Enter Zone Group Name"
                            type="text"
                            name="name"
                            onChange={(e) => handleZoneNameChange(e.target.value)}
                            value={zoneGroupValue}
                          />
                          {zoneTouchToggle && zoneGroupValue === "" && (
                            <div className="error-message">
                              Please enter zone group
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="added-zone-control mb-5">
                      <button
                        className="btn subscription-button"
                        type="submit"
                        onClick={handlesubmitzonegroup}
                      >
                        Save Zone Group
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-dark dark-outline-btn"
                        onClick={clearSelection}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="home-device-box">
                  <div className="top_bar">
                    <div className="card_title">Create New Zone</div>
                    <div className="form_field_wrapper">
                      <button
                        className="url-button closebutton"
                        onClick={closeCard}
                      >
                        <i class="bi bi-x-circle"></i>
                      </button>
                    </div>
                  </div>
                  <div className="bottom_bar">
                    <Formik
                      onSubmit={handleSubmit}
                      initialValues={zoneData}
                      enableReinitialize
                      validationSchema={zoneSchema}
                    >
                      {({
                        errors,
                        values,
                        touched,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        setFieldValue,
                      }) => (
                        <Form>
                          <div>
                            <div className="form_field_wrapper">
                              <label>Zone Name</label>
                              <Field
                                className="form-control"
                                placeholder="Enter Zone Name"
                                type="text"
                                name="name"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.name}
                              />
                              {errors.name && touched.name && (
                                <div className="error-message">
                                  {errors.name}
                                </div>
                              )}
                            </div>
                            <div className="form_field_wrapper">
                              <label>Devices added to zone</label>
                              <MultiSelectCheckbox
                                selectedDevices={selectedDevices}
                                setSelectedDevices={setSelectedDevices}
                                deviceTouchToggle={deviceTouchToggle}
                                setDeviceTouchToggle={setDeviceTouchToggle}
                                optionData={deviceList}
                              />
                              {deviceTouchToggle &&
                                selectedDevices?.length === 0 && (
                                  <div className="error-message">
                                    Please select device
                                  </div>
                                )}
                            </div>

                            <div className="form_field_wrapper">
                              <label>Zone Location</label>
                              <PlaceAutocomplete
                                onPlaceSelect={(place) => {
                                  const updatedZone = {
                                    ...values,
                                    latitude: place?.latitude || values.latitude,
                                    longitude: place?.longitude || values.longitude,
                                    zoneLocation: place?.address || values.zoneLocation,
                                  };
                                  // console.log("place:", place);
                                  setFieldValue("latitude", place?.latitude);
                                  setFieldValue("longitude", place?.longitude);
                                  setFieldValue("zoneLocation", place?.address);
                                  onSelectZone(updatedZone)
                                }}
                                latitude={values?.latitude}
                                longitude={values?.longitude}
                              />
                              {errors.zoneLocation && (touched.zoneLocation || touched.latitude) && (
                                <div className="error-message">
                                  {errors.zoneLocation}
                                </div>
                              )}
                            </div>

                            <div className="zones-progress-block">
                              <label>
                                Zone Radius{" "}
                                <span className="radius-value">
                                  <input
                                    type="number"
                                    className="form-input"
                                    name="radiusInMiles"
                                    min="1"
                                    max="5000"
                                    value={values.radiusInMiles ?? values.radius}
                                    // onChange={handleChange}
                                    onChange={(e) => {
                                      const updatedZone = {
                                        ...values,
                                        radiusInMiles: e.target.value,
                                      };
                                      setFieldValue("radiusInMiles", e.target.value);
                                      onSelectZone(updatedZone);
                                    }}
                                  />
                                  {/* {values.radiusInMiles ?? values.radius}  */}
                                  miles
                                </span>
                              </label>
                              <div className="zone-range">
                                <input
                                  type="range"
                                  className="form-range"
                                  name="radiusInMiles"
                                  defaultValue={5}
                                  min="1"
                                  max="5000"
                                  value={values.radiusInMiles ?? values.radius}
                                  // onChange={handleChange}
                                  // onChange={(e) => {
                                  //   setFieldValue("radiusInMiles", e.target.value);
                                  //   onSelectZone(e.target.value); // Call function with updated value
                                  // }}
                                  onChange={(e) => {
                                    const updatedZone = {
                                      ...values,
                                      radiusInMiles: e.target.value,
                                    };
                                    setFieldValue("radiusInMiles", e.target.value);
                                    onSelectZone(updatedZone);
                                  }}
                                />
                              </div>
                            </div>

                            <div className="added-zone-control">
                              <button
                                className="btn subscription-button"
                                type="submit"
                                onClick={() => setDeviceTouchToggle(true)}
                              >
                                Save Zone
                              </button>
                              <button
                                type="button"
                                className="btn btn-outline-dark dark-outline-btn"
                              >
                                Remove Zone
                              </button>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        <DeleteModal
          show={deleteshow}
          handleClose={handleClosedelete}
          handleDeleteData={DeleteData}
        />
      </>
    </APIProvider>
  );
}

const PlaceAutocomplete = ({ onPlaceSelect, latitude, longitude }) => {
  const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
  const [initialAddress, setInitialAddress] = useState("");
  const inputRef = useRef(null);
  const places = useMapsLibrary("places");

  //  Reverse geocoding to get address from lat/lng
  useEffect(() => {
    if (latitude && longitude && window.google) {
      const geocoder = new window.google.maps.Geocoder();
      const location = { lat: parseFloat(latitude), lng: parseFloat(longitude) };

      console.log("location", location)
      geocoder.geocode({ location }, (results, status) => {
        if (status === "OK" && results[0]) {
          setInitialAddress(results[0].formatted_address);
        } else {
          console.error("Geocoder failed due to: " + status);
        }
      });
    }
  }, [latitude, longitude]);

  useEffect(() => {
    if (!places || !inputRef.current || !window.google) return;

    const options = {
      fields: ["geometry", "name", "formatted_address"],
    };

    setPlaceAutocomplete(new window.google.maps.places.Autocomplete(inputRef.current, options));
  }, [places]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    placeAutocomplete.addListener("place_changed", () => {
      const place = placeAutocomplete.getPlace();
      if (place.geometry) {
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        onPlaceSelect({
          name: place.name,
          address: place.formatted_address,
          latitude,
          longitude,
        });
      }
    });
  }, [placeAutocomplete, onPlaceSelect]);

  return (
    <input
      ref={inputRef}
      className="form-control"
      placeholder="Select a location"
      defaultValue={initialAddress}
    />
  );
};


export default AddZones;
